import { BlogPost, author } from '../content/blog/blogData';

interface DbBlogPost {
  id: string;
  slug: string;
  title: string;
  metaTitle: string;
  metaDescription: string;
  excerpt: string;
  content: string;
  category: string;
  tags: string[];
  image: string;
  readTime: number;
  likes: number;
  comments: number;
  featured: boolean;
  noAds?: boolean;
  publishedAt: string;
}

export async function fetchBlogPosts(): Promise<BlogPost[]> {
  const response = await fetch('/.netlify/functions/blog-posts');

  if (!response.ok) {
    throw new Error(`blog-posts fetch failed: ${response.status}`);
  }

  const rows: DbBlogPost[] = await response.json();

  return rows.map((row) => ({
    id: row.id,
    slug: row.slug,
    title: row.title,
    metaTitle: row.metaTitle,
    metaDescription: row.metaDescription,
    excerpt: row.excerpt,
    content: row.content,
    category: row.category,
    tags: row.tags,
    image: row.image,
    readTime: row.readTime,
    likes: row.likes,
    comments: row.comments,
    featured: row.featured,
    noAds: row.noAds,
    publishedAt: row.publishedAt,
    author,
    seoKeywords: [],
    internalLinks: [],
  }));
}
